// extracted by mini-css-extract-plugin
module.exports = {"block":"_7842","title":"_2491","content":"_15086","more":"_9996","arrow":"_4091","store":"_13651","guide":"_19294"};